<template>
  <v-container grid-list-md>
    <v-tabs @change="onChangeTabs">
      <v-tab ripple>
        詳細
      </v-tab>
      <v-tab ripple>
        グラフ
      </v-tab>
      <v-tab ripple>
        センサーデータ
      </v-tab>
      <v-tab ripple>
        履歴
      </v-tab>
      <v-tab-item>
        <SensorDetailInfo
          :sensor="sensor"
          :customer="customer"
        />
      </v-tab-item>
      <v-tab-item>
        <SensorDetailGraph
          ref="graph"
          :records="records"
        />
      </v-tab-item>
      <v-tab-item>
        <SensorDetailTable
          :records="records"
        />
      </v-tab-item>
      <v-tab-item />
    </v-tabs>
  </v-container>
</template>

<script>
import { SensorDetailInfo, SensorDetailGraph, SensorDetailTable } from './components'
import { api } from '@/api'

const opt = { includes: 'customer,records' }

export default {
  components: {
    SensorDetailInfo,
    SensorDetailGraph,
    SensorDetailTable
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await api.getSensor(to.params.id, opt)
      next(vm => {
        vm.sensor = response.sensor
        vm.records = response.records
      })
    } catch (e) {
      next(e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      const response = await api.getSensor(to.params.id, opt)
      this.sensor = response.sensor
      this.records = response.records
      next()
    } catch (e) {
      next(e)
    }
  },
  data: () => ({
    sensor: {},
    customer: {},
    records: []
  }),
  methods: {
    onChangeTabs (event) {
      if (event === 1) {
        this.$refs.graph.draw()
      }
    }
  }
}
</script>
